import { DashboardPanel } from '../../../ui/features/dashboards';
import { SourcePanel } from '../../../ui/features/sources/components/SourcePanel';
import { VisualPanel } from '../../../ui/features/visuals/components/VisualPanel';
import { useLogiReportsTranslation, useLogiUser } from '../../../ui/hooks';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { PageError } from '@juvare/common-web-ui/PageError';
import { PageHeader } from '@juvare/common-web-ui/PageHeader';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Box, Typography } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';
import { Navigate, Route, Routes, matchPath, useLocation, useNavigate, useResolvedPath } from 'react-router';
export const LogiPanel = (props) => {
    const { t } = useLogiReportsTranslation();
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const currentPath = useResolvedPath('.');
    const location = useLocation();
    const [tab, setTab] = React.useState(false);
    const { data: logiUserData, error: logiUserError, isLoading: logiUserIsLoading } = useLogiUser();
    if (logiUserError) {
        handleErrorSnackbar(logiUserError);
    }
    const handleTabChange = (_event, value) => {
        navigationContext.navigate(() => {
            if (value === 'dashboards') {
                navigate(dashboardsLink);
            }
            else {
                navigate(value);
            }
        });
    };
    const showVisuals = logiUserData === null || logiUserData === void 0 ? void 0 : logiUserData.activeRoles.includes('ROLE_CREATE_VISUALS');
    const showSources = logiUserData === null || logiUserData === void 0 ? void 0 : logiUserData.activeRoles.includes('ROLE_CREATE_SOURCES');
    const matchTabPath = (tabPath) => matchPath(currentPath.pathname + tabPath, location.pathname);
    const dashboardsPathMatched = matchTabPath('/dashboards/*');
    const visualsPathMatched = matchTabPath('/visuals/*');
    const sourcesPathMatched = matchTabPath('/sources/*');
    let pageTitle = '';
    if (dashboardsPathMatched) {
        pageTitle = t('panels.dashboards.title');
    }
    else if (visualsPathMatched) {
        pageTitle = t('panels.visuals.title');
    }
    else if (sourcesPathMatched) {
        pageTitle = t('panels.sources.title');
    }
    React.useEffect(() => {
        if (logiUserIsLoading) {
            return;
        }
        if (dashboardsPathMatched) {
            setTab('dashboards');
        }
        else if (visualsPathMatched) {
            if (showVisuals) {
                setTab('visuals');
            }
            else {
                navigate(dashboardsLink, { replace: true });
            }
        }
        else if (sourcesPathMatched) {
            if (showSources) {
                setTab('sources');
            }
            else {
                navigate(dashboardsLink, { replace: true });
            }
        }
    }, [dashboardsPathMatched, visualsPathMatched, sourcesPathMatched, navigate, logiUserIsLoading, showVisuals, showSources]);
    const showTabs = matchTabPath('/dashboards') || matchTabPath('/visuals') || matchTabPath('/sources');
    return (React.createElement(React.Fragment, null,
        showTabs && (React.createElement(React.Fragment, null,
            !props.hideHeader && (React.createElement(PageHeader, { gradient: 'blue-base' },
                React.createElement(Typography, { variant: 'h1', sx: { p: 4 } }, pageTitle))),
            React.createElement(Box, { sx: {
                    pl: 4,
                    pr: 4,
                    bgcolor: 'background.paper',
                    boxShadow: (theme) => theme.shadows[1],
                } },
                React.createElement(Tabs, { variant: 'scrollable', value: tab, onChange: handleTabChange },
                    React.createElement(Tab, { value: 'dashboards', label: t('panels.dashboards.title'), "data-test": 'dashboards' }),
                    showVisuals && React.createElement(Tab, { value: 'visuals', label: t('panels.visuals.title'), "data-test": 'visuals' }),
                    showSources && React.createElement(Tab, { value: 'sources', label: t('panels.sources.title'), "data-test": 'sources' }))))),
        logiUserError ? (React.createElement(PageError, { error: logiUserError })) : (React.createElement(Routes, null,
            React.createElement(Route, { index: true, element: React.createElement(Navigate, { to: dashboardsLink, replace: true }) }),
            React.createElement(Route, { path: '/dashboards/*', element: React.createElement(DashboardPanel, { hideHeader: true }) }),
            showVisuals && React.createElement(Route, { path: '/visuals/*', element: React.createElement(VisualPanel, { hideHeader: true }) }),
            showSources && React.createElement(Route, { path: '/sources/*', element: React.createElement(SourcePanel, { hideHeader: true }) })))));
};
const dashboardsLink = {
    pathname: 'dashboards',
};
